import { Check } from "lucide-react";
import { useLang } from "@/lib/i18n";
import { useSeo } from "@/lib/seo";
import { PageHero } from "@/components/PageHero";
import { MapPanel } from "@/components/home/MapPanel";
import { Reveal, Eyebrow, MaskLines } from "@/components/Motion";
import { QuoteBand } from "@/components/Section";

const Zone = ({ z, i }) => {
  const { t } = useLang();
  return (
    <section id={z.id} className={`scroll-mt-24 py-24 lg:py-32 ${i % 2 ? "bg-[#F7F9FB]" : "bg-white"}`} data-testid={`zone-${z.id}`}>
      <div className="mx-auto grid max-w-7xl gap-14 px-5 sm:px-8 lg:grid-cols-12 lg:px-12">
        <div className={`lg:col-span-6 ${i % 2 ? "lg:order-2" : ""}`}>
          <div className="relative aspect-[4/3] overflow-hidden">
            <img src={z.img} alt={z.name} loading="lazy" className="h-full w-full object-cover" />
            <span className="absolute bottom-0 start-0 h-1 w-24 bg-[#C59B27]" aria-hidden="true" />
          </div>
        </div>
        <div className="lg:col-span-6">
          <Eyebrow>{z.city}</Eyebrow>
          <h2 className="mt-5 font-serif text-3xl text-[#1E3A5F] sm:text-4xl lg:text-5xl"><MaskLines lines={[z.name]} onView /></h2>
          <Reveal><p className="mt-6 text-lg leading-relaxed text-[#334155]">{z.desc}</p></Reveal>
          <Reveal className="mt-10 border-t border-[#8EA3BC]/40 pt-8">
            <h3 className="text-xs font-semibold uppercase tracking-[0.18em] text-[#A27D17]">{t.common.whatWeOperate}</h3>
            <p className="mt-3 font-serif text-xl leading-snug text-[#1E3A5F]">{z.operate}</p>
          </Reveal>
          <Reveal className="mt-10 border-t border-[#8EA3BC]/40 pt-8">
            <h3 className="text-xs font-semibold uppercase tracking-[0.18em] text-[#A27D17]">{t.common.servicesAtSite}</h3>
            <ul className="mt-4 grid gap-3 sm:grid-cols-2">
              {z.services.map((s) => (
                <li key={s} className="flex items-start gap-3 text-[#1E293B]"><Check className="mt-1 h-4 w-4 shrink-0 text-[#1E3A5F]" aria-hidden="true" />{s}</li>
              ))}
            </ul>
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export default function Locations() {
  const { t } = useLang();
  const p = t.locationsPage;
  useSeo("locations");
  return (
    <>
      <PageHero eyebrow={p.eyebrow} title={p.title} intro={p.intro} img="/img/julyana.jpg" testId="locations-hero" />
      <section className="bg-white pt-24" data-testid="locations-map">
        <div className="mx-auto max-w-7xl px-5 sm:px-8 lg:px-12"><MapPanel showLinks={false} /></div>
      </section>
      {p.zones.map((z, i) => <Zone key={z.id} z={z} i={i} />)}
      <QuoteBand testId="locations-quote-band" />
    </>
  );
}
